// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"4223":"commons","8096":"vendors"}[chunkId] || chunkId) + ".js";
};